module.exports = __webpack_public_path__ + "img/Gulati.56231155.jpeg";